import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import { DSAudioPlayIcon, DSAudioPauseIcon } from '@ds-icons';

const PlayerButtons = ({ isPlaying, onPause, onPlay }) => {
  const PlayPauseIcon = isPlaying ? DSAudioPauseIcon : DSAudioPlayIcon;
  const playPauseHandler = isPlaying ? onPause : onPlay;

  return <PlayPauseIcon onClick={playPauseHandler} />;
};

PlayerButtons.defaultProps = {
  isPlaying: false,
  onPause: noop,
  onPlay: noop
};

PlayerButtons.propTypes = {
  isPlaying: PropTypes.bool,
  onPause: PropTypes.func,
  onPlay: PropTypes.func
};

export default PlayerButtons;
